import { AnalyticsEvent } from "./enums/analytics-event.enum";
import { getEventName } from "./get-event-name";
import { IABTest } from "./interfaces/abtest.interface";
import { IAnalyticsBindEventData } from "./interfaces/analytics-data.interface";
import { IAnalyticsSystem } from "./interfaces/analytics-system.interface";

declare global {
  interface Window {
    _tmr: any;
    opera: any;
  }
}

export class MailRu implements IAnalyticsSystem {
  constructor(
    private readonly id: string, 
    private readonly bindEventsList?: IAnalyticsBindEventData[],
    private readonly prefix: string = "",
  ) {}
  
  init() {
    var _tmr = window._tmr || (window._tmr = []);
    _tmr.push({id: this.id, type: "pageView", start: (new Date()).getTime()});
    (function (d, w, id) {
      if (d.getElementById(id)) return;
      var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
      ts.src = "https://top-fwz1.mail.ru/js/code.js";
      var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode?.insertBefore(ts, s);};
      if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
    })(document, window, "tmr-code");
  }

  public setParams(params: Record<string, any>) {}

  public track(event: AnalyticsEvent, params?: Record<string, any>) {
    const eventName = getEventName(event, params, this.bindEventsList, this.prefix);
    window._tmr.push({ id: this.id, type: "reachGoal", goal: eventName });
  }

  public setABTest(abTest: IABTest) { }
}